// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__SmeKm","search":"Settings_search__pIlzG","filter":"Settings_filter__3K4kb"};